(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockZusammenfassungVorversicherung', {
            bindings: {
                vorversicherung: '<abzvVorversicherung',
                title: '@abzvTitle',
                options: '<abzvOptions'
            },
            templateUrl: 'bloecke/zusammenfassung/blockZusammenfassungVorversicherung.html',
            controller: BlockZusammenfassungVorversicherungController,
            controllerAs: 'vorversicherungVm'
        });

    BlockZusammenfassungVorversicherungController.$inject = [
        'lodash',
        'BasisAngebotService'
    ];
    function BlockZusammenfassungVorversicherungController(_, BasisAngebotService) {
        var vm = this;

        vm.$onInit = onInit;

        function activate() {
            var vorversicherungsarten = BasisAngebotService.getConstant('vorversicherungsarten') || {};

            vm.gridLayoutCss = _.get(vm.options, 'grid') || {};

            if (!vm.gridLayoutCss.columnLeft) {
                vm.gridLayoutCss.columnLeft = 'small-12 medium-6';
            }

            if (!vm.gridLayoutCss.columnRight) {
                vm.gridLayoutCss.columnRight = 'small-12 medium-6';
            }

            vm.CONSTANTS = {
                vorversicherungFremdversicherung: vorversicherungsarten.fremdversicherung,
                vorversicherungUnternehmen: vorversicherungsarten.unternehmen,
                vorversicherungGekuendigtVon: _.toArray(BasisAngebotService.getConstant('vorversicherungGekuendigtVon'))
            };
        }

        function onInit() {
            activate();
        }
    }

})();
